export default {
  networkName: process.env.VUE_APP_NETWORK_NAME,
  networkFullName: process.env.VUE_APP_NETWORK_FULL_NAME,
  apiUrl: process.env.VUE_APP_API_URL,
  minotarUrl: "https://minotar.net/helm",
  noUnbanReasons: process.env.VUE_APP_NO_UNBAN_REASONS.split(","),
  typeSortOrder: ["BAN", "MUTE", "KICK", "WARN", "IP", "PLAYER", "PLAYER_MUTE"]
};
